export default [
  { value: '16-17', label: '16-17' },
  { value: '18-24', label: '18-24' },
  { value: '25-29', label: '25-29' },
  { value: '30-34', label: '30-34' },
  { value: '35-39', label: '35-39' },
  { value: '40-44', label: '40-44' },
  { value: '45-49', label: '45-49' },
  { value: '50-54', label: '50-54' },
  { value: '55+', label: '55+' }
];
